// import React, { useState, useEffect } from "react";
// import { Clock, CheckCircle, XCircle, Eye, RotateCcw } from "lucide-react";
// import PreFooter from "components/footers/PreFooterBrand.js";
// import Footer from "components/footers/SimpleFiveColumn.js";
// import { HomeScreen } from "components/readalong/homescreen";
// import { ResultScreen1 } from "components/readalong/resultscreen";
// import { SolutionScreen } from "components/readalong/solutionscreen";
// import { TestScreen } from "components/readalong/testscreen";
// import { RelatedArticles } from "components/readalong/realatedArticle";
// import { serverUtilities } from "services/serverutilities.service";

// const DepreciationTestUI = () => {
//   const [currentScreen, setCurrentScreen] = useState("home");
//   const [testStarted, setTestStarted] = useState(false);
//   const [currentQuestion, setCurrentQuestion] = useState(0);
//   const [answers, setAnswers] = useState({});
//   const [timer, setTimer] = useState(0);
//   const [data, setData] = useState(null);
//   const [selectedQuestionTypes, setSelectedQuestionTypes] = useState({
//     mcq: true,
//     fillBlank: true,
//     // multipleChoiceFillBlank: true,
//   });
//   const[testData, settestData] = useState([])




//   // Sample test data with only MCQ and fill-in-the-blank questions
//   // const testData = {
//   //   passage: `Depreciation is the systematic allocation of the cost of a tangible asset over its useful life...`,
//   //   audioUrl: "https://www.soundjay.com/misc/sounds/bell-ringing-05.wav",
//   //   videoUrl:
//   //     "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",

//   //   questions: [
//   //     // MCQ
//   //     {
//   //       id: 1,
//   //       type: "mcq",
//   //       question: "What is depreciation?",
//   //       options: [
//   //         "The increase in value of an asset over time",
//   //         "The systematic allocation of the cost of a tangible asset over its useful life",
//   //         "The immediate expense of purchasing an asset",
//   //         "The market value of an asset",
//   //       ],
//   //       correct: 1,
//   //     },
//   //     {
//   //       id: 6,
//   //       type: "mcq",
//   //       question: "What is depreciation?",
//   //       options: [
//   //         "The increase in value of an asset over time",
//   //         "The systematic allocation of the cost of a tangible asset over its useful life",
//   //         "The immediate expense of purchasing an asset",
//   //         "The market value of an asset",
//   //       ],
//   //       correct: 1,
//   //     },

//   //     // Fill in the blank
//   //     {
//   //       id: 2,
//   //       type: "fillBlank",
//   //       question:
//   //         "The __________ method is the most commonly used depreciation approach, while the __________ method accelerates depreciation in early years.",
//   //       blanks: [
//   //         { correct: "straight-line" },
//   //         { correct: "declining balance" },
//   //       ],
//   //       options: [], // Not used for fillBlank
//   //     },
//   //     {
//   //       id: 3,
//   //       type: "multipleChoiceFillBlank",
//   //       question:
//   //         "The __________ method spreads depreciation evenly over an asset's useful life.",
//   //       options: [
//   //         "straight-line",
//   //         "declining balance",
//   //         "units of production",
//   //         "sum-of-the-years-digits",
//   //       ],
//   //       correct: "straight-line",
//   //     },
//   //   ],
//   // };

//   const relatedArticles = [
//     {
//       title:
//         "Learn Depreciation for CA Foundation: Easy Explanation & Examples",
//       description:
//         "Complete guide to understanding depreciation concepts for CA Foundation students.",
//     },
//     {
//       title: "Depreciation Solved Examples for CA Foundation - Part 1",
//       description:
//         "Practice problems and solutions for depreciation calculations.",
//     },
//   ];

//   // Filter questions based on selected types
//   const filteredQuestions = testData?.questions?.filter(
//     (q) => selectedQuestionTypes[q.type]
//   );

// useEffect(() => {
//   const fetchData = async () => {
//     try {
//       const datamain = await serverUtilities.getTestList();
//       console.log("datamain response:", datamain);
//       const transformedData = transformApiResponse(datamain?.vals);
// console.log('transformedData',transformedData);
// settestData(transformedData)
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   fetchData();
// }, []);
// function transformApiResponse(apiResponse) {
//   const testData = {
//     passage: apiResponse.ex_passage,
//     audioUrl: apiResponse.a_s3_url, // Add if available
//     videoUrl: apiResponse?.v_s3_url, // Add if available
//     questions: apiResponse.ex_qs.map((q, index) => {
//       const baseQuestion = {
//         id: index + 1,
//         question: q.question,
//       };
      
//       if (q.q_type === "MCQ") {
//         return {
//           ...baseQuestion,
//           type: "mcq",
//           options: q.options,
//           correct: parseInt(q.answer) - 1, // Converting to 0-based index
//         };
//       } else if (q.q_type === "FIB") {
//         // For fill in the blank questions
//         return {
//           ...baseQuestion,
//           type: "fillBlank",
//           options: q.options.length > 0 ? q.options : [], // Some FIB might have options
//           // correct: q.answer, // The correct answer text
//             blanks: [{ correct: q.answer }],
//         };
//       }
      
//       // Default return (you might want to handle other types)
//       return baseQuestion;
//     }),
//   };
  
//   return testData;
// }

// // const transformedData = transformApiResponse(apiResponse);
// // console.log('transformedData',transformedData);

//   useEffect(() => {
//     let interval;
//     if (testStarted && currentScreen === "test") {
//       interval = setInterval(() => {
//         setTimer((prev) => prev + 1);
//       }, 1000);
//     }
//     return () => clearInterval(interval);
//   }, [testStarted, currentScreen]);

//   const startTest = () => {
//     setTestStarted(true);
//     setCurrentScreen("test");
//     setCurrentQuestion(0);
//     setAnswers({});
//   };

//   const handleAnswerSelect = (questionId, answerIndex) => {
//     setAnswers((prev) => ({
//       ...prev,
//       [questionId]: answerIndex,
//     }));
//   };

//   const handleFillBlankInput = (questionId, answerValue) => {
//     setAnswers((prev) => ({
//       ...prev,
//       [questionId]: answerValue,
//     }));
//   };

//   const nextQuestion = () => {
//     if (currentQuestion < filteredQuestions.length - 1) {
//       setCurrentQuestion((prev) => prev + 1);
//     }
//   };

//   const previousQuestion = () => {
//     if (currentQuestion > 0) {
//       setCurrentQuestion((prev) => prev - 1);
//     }
//   };

//   const submitTest = () => {
//     setCurrentScreen("result");
//   };

//   const jumpToQuestion = (index) => {
//     setCurrentQuestion(index);
//   };

//   const calculateResults = () => {
//     let correct = 0;
//     let attempted = 0;
// console.log('filterdeddeded',filteredQuestions)
//     filteredQuestions.forEach((q) => {
//       if (answers[q.id] !== undefined && answers[q.id] !== null) {
//         attempted++;

//         if (q.type === "mcq") {
//           if (answers[q.id] === q.correct) correct++;
//         } else if (q.type === "fillBlank") {
//           const userAnswer = answers[q.id];

//           if (
//             Array.isArray(userAnswer) &&
//             Array.isArray(q.blanks) &&
//             userAnswer.length === q.blanks.length &&
//             q.blanks.every(
//               (blank, index) =>
//                 userAnswer[index]?.toLowerCase() ===
//                 blank?.correct?.toLowerCase()
//             )
//           ) {
//             correct++;
//           }
//         } else if (q.type === "multipleChoiceFillBlank") {
//           if (answers[q.id]?.toLowerCase() === q.correct?.toLowerCase()) {
//             correct++;
//           }
//         }
//       }
//     });

//     return { correct, attempted, total: filteredQuestions.length };
//   };

//   const resetTest = () => {
//     setCurrentScreen("home");
//     setTestStarted(false);
//     setCurrentQuestion(0);
//     setAnswers({});
//     setTimer(0);
//   };

//   const viewSolutions = () => {
//     setCurrentScreen("solutions");
//   };

//   const backToResults = () => {
//     setCurrentScreen("result");
//   };

//   const toggleQuestionType = (type) => {
//     setSelectedQuestionTypes((prev) => ({
//       ...prev,
//       [type]: !prev[type],
//     }));
//   };

//   const styles = {
//     container: {
//       minHeight: "100vh",
//       background: "linear-gradient(135deg, #fce4ec 0%, #f3e5f5 100%)",
//       padding: "32px 16px",
//     },
//     innerContainer: {
//       maxWidth: "1200px",
//       margin: "0 auto",
//       padding: "0 16px",
//     },
//     questionTypeSelector: {
//       display: "flex",
//       flexWrap: "wrap",
//       gap: "10px",
//       marginBottom: "20px",
//     },
//     questionTypeButton: {
//       padding: "8px 16px",
//       borderRadius: "20px",
//       border: "1px solid #ddd",
//       background: "#fff",
//       cursor: "pointer",
//     },
//     selectedQuestionType: {
//       background: "#2563eb",
//       color: "#fff",
//       borderColor: "#2563eb",
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.innerContainer}>
//         {currentScreen === "home" && (
//           <div>
//             <div style={styles.questionTypeSelector}>
//               <h3>Select Question Types:</h3>
//               <button
//                 style={{
//                   ...styles.questionTypeButton,
//                   ...(selectedQuestionTypes.mcq
//                     ? styles.selectedQuestionType
//                     : {}),
//                 }}
//                 onClick={() => toggleQuestionType("mcq")}
//               >
//                 Multiple Choice
//               </button>
//               <button
//                 style={{
//                   ...styles.questionTypeButton,
//                   ...(selectedQuestionTypes.fillBlank
//                     ? styles.selectedQuestionType
//                     : {}),
//                 }}
//                 onClick={() => toggleQuestionType("fillBlank")}
//               >
//                 Fill in Blank
//               </button>
//               <button
//                 style={{
//                   ...styles.questionTypeButton,
//                   ...(selectedQuestionTypes.multipleChoiceFillBlank
//                     ? styles.selectedQuestionType
//                     : {}),
//                 }}
//                 onClick={() => toggleQuestionType("multipleChoiceFillBlank")}
//               >
//                 MC Fill Blank
//               </button>
//             </div>
//             <HomeScreen
//               startTest={startTest}
//               relatedArticles={relatedArticles}
//             />
//           </div>
//         )}

//         {currentScreen === "test" && (
//           <TestScreen
//             testData={{
//               ...testData,
//               questions: filteredQuestions,
//             }}
//             currentQuestion={currentQuestion}
//             answers={answers}
//             timer={timer}
//             relatedArticles={relatedArticles}
//             handleAnswerSelect={handleAnswerSelect}
//             handleFillBlankInput={handleFillBlankInput}
//             nextQuestion={nextQuestion}
//             previousQuestion={previousQuestion}
//             submitTest={submitTest}
//             resetTest={resetTest}
//             startTest={startTest}
//             jumpToQuestion={jumpToQuestion}
//           />
//         )}

//         {currentScreen === "result" && (
//           <ResultScreen1
//             results={calculateResults()}
//             timer={timer}
//             relatedArticles={relatedArticles}
//             viewSolutions={viewSolutions}
//             resetTest={resetTest}
//           />
//         )}

//         {currentScreen === "solutions" && (
//           <SolutionScreen
//             testData={{
//               ...testData,
//               questions: filteredQuestions,
//             }}
//             answers={answers}
//             relatedArticles={relatedArticles}
//             backToResults={backToResults}
//             resetTest={resetTest}
//           />
//         )}
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default DepreciationTestUI;



import React, { useState, useEffect } from "react";
import { Clock, CheckCircle, XCircle, Eye, RotateCcw } from "lucide-react";
import PreFooter from "components/footers/PreFooterBrand.js";
import Footer from "components/footers/SimpleFiveColumn.js";
import { HomeScreen } from "components/readalong/homescreen";
import { ResultScreen1 } from "components/readalong/resultscreen";
import { SolutionScreen } from "components/readalong/solutionscreen";
import { TestScreen } from "components/readalong/testscreen";
import ParagraphTestScreen from "components/readalong/paragrapscreen";
import { RelatedArticles } from "components/readalong/realatedArticle";
import { serverUtilities } from "services/serverutilities.service";

const DepreciationTestUI = () => {
  const [currentScreen, setCurrentScreen] = useState("home");
  const [testStarted, setTestStarted] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [timer, setTimer] = useState(0);
  const [data, setData] = useState(null);
  const [selectedQuestionTypes, setSelectedQuestionTypes] = useState({
    mcq: true,
    fillBlank: true,
  });
  const [testFormat, setTestFormat] = useState("normal");
  const [testData, settestData] = useState([]);
  const [questionTimes, setQuestionTimes] = useState({});
  const [attemptedAnswers, setAttemptedAnswers] = useState({});

  const relatedArticles = [
    {
      title: "Learn Depreciation for CA Foundation: Easy Explanation & Examples",
      description: "Complete guide to understanding depreciation concepts for CA Foundation students.",
    },
    {
      title: "Depreciation Solved Examples for CA Foundation - Part 1",
      description: "Practice problems and solutions for depreciation calculations.",
    },
  ];

  // Filter questions based on selected types
  const filteredQuestions = testData?.questions?.filter(
    (q) => selectedQuestionTypes[q.type]
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const datamain = await serverUtilities.getTestList();
        console.log("datamain response:", datamain);
        const transformedData = transformApiResponse(datamain?.vals);
        settestData(transformedData);
        console.log('transformedData', transformedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  function transformApiResponse(apiResponse) {
    const testData = {
      passage: apiResponse.ex_passage,
      audioUrl: apiResponse.a_s3_url,
      videoUrl: apiResponse?.v_s3_url,
      questions: apiResponse.ex_qs.map((q, index) => {
        const baseQuestion = {
          id: index + 1,
          question: q.question,
        };
        
        if (q.q_type === "MCQ") {
          return {
            ...baseQuestion,
            type: "mcq",
            options: q.options,
            correct: parseInt(q.answer) - 1,
          };
        } else if (q.q_type === "FIB") {
          return {
            ...baseQuestion,
            type: "fillBlank",
            options: q.options.length > 0 ? q.options : [],
            blanks: [{ correct: q.answer }],
          };
        }
        
        return baseQuestion;
      }),
    };
    
    return testData;
  }

  useEffect(() => {
    let interval;
    if (testStarted && currentScreen === "test") {
      interval = setInterval(() => {
        setTimer((prev) => prev + 1);
        // Update time for current question
        setQuestionTimes(prev => ({
          ...prev,
          [currentQuestion]: (prev[currentQuestion] || 0) + 1
        }));
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [testStarted, currentScreen, currentQuestion]);

  const startTest = () => {
    setTestStarted(true);
    setCurrentScreen("test");
    setCurrentQuestion(0);
    setAnswers({});
    setAttemptedAnswers({});
    setQuestionTimes({});
  };

  const handleAnswerSelect = (questionId, answerIndex) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: answerIndex,
    }));
    
    setAttemptedAnswers((prev) => ({
      ...prev,
      [questionId]: answerIndex,
    }));
  };

  const handleFillBlankInput = (questionId, answerValue) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: answerValue,
    }));
    
    setAttemptedAnswers((prev) => ({
      ...prev,
      [questionId]: answerValue,
    }));
  };

  const nextQuestion = () => {
    if (currentQuestion < filteredQuestions.length - 1) {
      setCurrentQuestion((prev) => prev + 1);
    }
  };

  const previousQuestion = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion((prev) => prev - 1);
    }
  };

  const submitTest = () => {
  // Calculate results
  const results = calculateResults();
  
  // Calculate question-wise stats
  const questionStats = filteredQuestions.map((q, index) => {
    const userAnswer = answers[q.id];
    let status;
    let correctAnswer;
    let userAttemptedAnswer = attemptedAnswers[q.id] || ""; // Default to empty string
    
    if (q.type === "mcq") {
      correctAnswer = q.options[q.correct];
      if (userAnswer === undefined || userAnswer === null) {
        status = 0; // Not attempted
        userAttemptedAnswer = "";
      } else {
        status = userAnswer === q.correct ? 1 : -1;
        userAttemptedAnswer = q.options[userAnswer] || "";
      }
    } else if (q.type === "fillBlank") {
      correctAnswer = q.blanks[0]?.correct;
      if (userAnswer === undefined || userAnswer === null) {
        status = 0; // Not attempted
        userAttemptedAnswer = "";
      } else if (typeof userAnswer === "string" && typeof correctAnswer === "string") {
        status = userAnswer.toLowerCase() === correctAnswer.toLowerCase() ? 1 : -1;
        userAttemptedAnswer = userAnswer;
      } else {
        status = -1;
        userAttemptedAnswer = "";
      }
    }
    
    return {
      questionId: q.id,
      questionText: q.question,
      status, // 1 (correct), -1 (incorrect), 0 (not attempted)
      timeSpent: questionTimes[index] || 0,
      correctAnswer,
      userAttemptedAnswer
    };
  });

  // Prepare the data object to log
  const testSummary = {
    totalQuestions: results.total,
    totalCorrect: results.correct,
    totalIncorrect: results.attempted - results.correct,
    totalNotAttempted: results.total - results.attempted,
    totalTime: timer, // Total time in seconds
    questionStats: questionStats,
    answerStatusArray: results.answerStatusArray,
    questionTimeArray: results.questionTimeArray, // Array of time spent per question
    attemptedAnswersArray: results.attemptedAnswersArray // Array with empty strings for unattempted
  };

  console.log("Test Summary:", testSummary);
  
  // Navigate to results screen
  setCurrentScreen("result");
};
  const jumpToQuestion = (index) => {
    setCurrentQuestion(index);
  };

const calculateResults = () => {
  let correct = 0;
  let attempted = 0;
  const answerStatusArray = [];
  const questionTimeArray = [];
  const attemptedAnswersArray = [];

  filteredQuestions.forEach((q, index) => {
    // Get time spent on this question (default to 0 if not tracked)
    const timeSpent = questionTimes[index] || 0;
    questionTimeArray.push(timeSpent);

    if (answers[q.id] !== undefined && answers[q.id] !== null) {
      attempted++;
      
      let isCorrect = false;
      let userAnswer = answers[q.id];
      
      if (q.type === "mcq") {
        isCorrect = userAnswer === q.correct;
        attemptedAnswersArray.push(q.options[userAnswer] || "");
      } else if (q.type === "fillBlank") {
        isCorrect = typeof userAnswer === "string" &&
                   typeof q.blanks[0]?.correct === "string" &&
                   userAnswer.toLowerCase() === q.blanks[0].correct.toLowerCase();
        attemptedAnswersArray.push(userAnswer || "");
      }

      if (isCorrect) {
        correct++;
        answerStatusArray.push(1); // Correct answer
      } else {
        answerStatusArray.push(-1); // Incorrect answer
      }
    } else {
      answerStatusArray.push(0); // Not attempted
      attemptedAnswersArray.push(""); // Empty string for unattempted
    }
  });

  return { 
    correct, 
    attempted, 
    total: filteredQuestions.length,
    answerStatusArray,
    questionTimeArray,
    attemptedAnswersArray
  };
};
  const resetTest = () => {
    setCurrentScreen("home");
    setTestStarted(false);
    setCurrentQuestion(0);
    setAnswers({});
    setAttemptedAnswers({});
    setQuestionTimes({});
    setTimer(0);
  };

  const viewSolutions = () => {
    setCurrentScreen("solutions");
  };

  const backToResults = () => {
    setCurrentScreen("result");
  };

  const toggleQuestionType = (type) => {
    setSelectedQuestionTypes((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  const toggleTestFormat = (format) => {
    setTestFormat(format);
  };

  const styles = {
    container: {
      minHeight: "100vh",
      background: "linear-gradient(135deg, #fce4ec 0%, #f3e5f5 100%)",
      padding: "32px 16px",
    },
    innerContainer: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "0 16px",
    },
    questionTypeSelector: {
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",
      marginBottom: "20px",
    },
    questionTypeButton: {
      padding: "8px 16px",
      borderRadius: "20px",
      border: "1px solid #ddd",
      background: "#fff",
      cursor: "pointer",
    },
    selectedQuestionType: {
      background: "#2563eb",
      color: "#fff",
      borderColor: "#2563eb",
    },
    testFormatSelector: {
      display: "flex",
      gap: "10px",
      marginBottom: "20px",
    },
    testFormatButton: {
      padding: "8px 16px",
      borderRadius: "20px",
      border: "1px solid #ddd",
      background: "#fff",
      cursor: "pointer",
    },
    selectedTestFormat: {
      background: "#2563eb",
      color: "#fff",
      borderColor: "#2563eb",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.innerContainer}>
        {currentScreen === "home" && (
          <div>
            <div style={styles.questionTypeSelector}>
              <h3>Select Question Types:</h3>
              <button
                style={{
                  ...styles.questionTypeButton,
                  ...(selectedQuestionTypes.mcq ? styles.selectedQuestionType : {}),
                }}
                onClick={() => toggleQuestionType("mcq")}
              >
                Multiple Choice
              </button>
              <button
                style={{
                  ...styles.questionTypeButton,
                  ...(selectedQuestionTypes.fillBlank ? styles.selectedQuestionType : {}),
                }}
                onClick={() => toggleQuestionType("fillBlank")}
              >
                Fill in Blank
              </button>
            </div>
            
            <div style={styles.testFormatSelector}>
              <h3>Test Format:</h3>
              <button
                style={{
                  ...styles.testFormatButton,
                  ...(testFormat === "normal" ? styles.selectedTestFormat : {}),
                }}
                onClick={() => toggleTestFormat("normal")}
              >
                Normal
              </button>
              <button
                style={{
                  ...styles.testFormatButton,
                  ...(testFormat === "paragraph" ? styles.selectedTestFormat : {}),
                }}
                onClick={() => toggleTestFormat("paragraph")}
              >
                Paragraph
              </button>
            </div>
            
            <HomeScreen
              startTest={startTest}
              relatedArticles={relatedArticles}
            />
          </div>
        )}

        {currentScreen === "test" && testFormat === "normal" && (
          <TestScreen
            testData={{
              ...testData,
              questions: filteredQuestions,
            }}
            currentQuestion={currentQuestion}
            answers={answers}
            timer={timer}
            relatedArticles={relatedArticles}
            handleAnswerSelect={handleAnswerSelect}
            handleFillBlankInput={handleFillBlankInput}
            nextQuestion={nextQuestion}
            previousQuestion={previousQuestion}
            submitTest={submitTest}
            resetTest={resetTest}
            startTest={startTest}
            jumpToQuestion={jumpToQuestion}
          />
        )}

        {currentScreen === "test" && testFormat === "paragraph" && (
          <ParagraphTestScreen
            testData={{
              ...testData,
              questions: filteredQuestions,
            }}
            answers={answers}
            timer={timer}
            relatedArticles={relatedArticles}
            handleAnswerSelect={handleAnswerSelect}
            handleFillBlankInput={handleFillBlankInput}
            submitTest={submitTest}
            resetTest={resetTest}
          />
        )}

        {currentScreen === "result" && (
          <ResultScreen1
            results={calculateResults()}
            timer={timer}
            relatedArticles={relatedArticles}
            viewSolutions={viewSolutions}
            resetTest={resetTest}
          />
        )}

        {currentScreen === "solutions" && (
          <SolutionScreen
            testData={{
              ...testData,
              questions: filteredQuestions,
            }}
            answers={answers}
            relatedArticles={relatedArticles}
            backToResults={backToResults}
            resetTest={resetTest}
          />
        )}
      </div>

      <Footer />
    </div>
  );
};

export default DepreciationTestUI;

// import React, { useEffect, useState, useRef } from 'react';

// export default function DepreciationTestUI() {
//     const [isPaused, setIsPaused] = useState(false);
//     const [isSpeaking, setIsSpeaking] = useState(false);
//     const utteranceRef = useRef(null);
//     const wordIndexRef = useRef(0);
//     const globalWordsRef = useRef([]);
//     const timingsRef = useRef({});
//     const startIndexRef = useRef(0); // Track where we started from
//     const dummyText = "This aus berlin is a demonstration of speech synthesis with word highlighting. When you click play, the text will be spoken and each word will be highlighted as it's spoken. You can pause and resume the speech, or click on any word to start from that point.";

//     useEffect(() => {
//         // Initialize speech synthesis
//         const utterance = new SpeechSynthesisUtterance();
//         utteranceRef.current = utterance;
//         utterance.lang = 'en-GB';
//         utterance.rate = 1;

//         // Function to set the desired voice
//         function setVoice() {
//             var voices = speechSynthesis.getVoices();
//             console.log('voices',voices)
//             var desiredVoice = voices.find(voice => voice.name === "Microsoft George - English (United Kingdom)");
//             if (desiredVoice) {
//                 utterance.voice = desiredVoice;
//             } else {
//                 console.error("Desired voice not found");
//             }
//         }

//         // Ensure voices are loaded
//         speechSynthesis.onvoiceschanged = function() {
//             setVoice();
//         };

//         // Set initial voice
//         setVoice();

//         // Draw the dummy text initially
//         drawTextInPanel(dummyText.split(" "));

//         // Cleanup function
//         return () => {
//             if (speechSynthesis.speaking) {
//                 speechSynthesis.cancel();
//             }
//         };
//     }, []);

//     const resetHighlighting = () => {
//         document.querySelectorAll("#panel span").forEach(span => {
//             span.style.color = "black";
//             span.style.fontWeight = "normal";
//         });
//     };

//     const highlightCurrentWord = (index) => {
//         resetHighlighting();
//         try {
//             const span = document.getElementById("word_span_" + index);
//             if (span) {
//                 span.style.color = "blue";
//                 span.style.fontWeight = "bold";
//             }
//         } catch(e) {
//             console.error("Error highlighting word:", e);
//         }
//     };

//     const handlePlay = () => {
//         if (isPaused) {
//             speechSynthesis.resume();
//             setIsPaused(false);
//             return;
//         }

//         // Reset if not paused
//         wordIndexRef.current = 0;
//         startIndexRef.current = 0;
//         timingsRef.current = {};
//         const words = dummyText.split(" ");
//         globalWordsRef.current = words;
        
//         drawTextInPanel(words);
        
//         const utterance = utteranceRef.current;
//         utterance.text = dummyText;
        
//         setupUtteranceCallbacks(utterance, 0);
        
//         speechSynthesis.speak(utterance);
//         setIsSpeaking(true);
//     };

//     const setupUtteranceCallbacks = (utterance, startFromIndex) => {
//       console.log('utterance',utterance)
//         utterance.onboundary = function(event) {
//           console.log('eventtt',event)
//             if (event.name === 'word') {
//                console.log('eventtt1111111111111')
//                 const currentTime = performance.now();
//                 const currentWordIndex = wordIndexRef.current;
//                 const absoluteWordIndex = startFromIndex + currentWordIndex;
//                  console.log('absoluteWordIndex',absoluteWordIndex)
//                 // Only process if we're within our global words array
//                 if (absoluteWordIndex < globalWordsRef.current.length) {
//                     const word = globalWordsRef.current[absoluteWordIndex];
//                     const wordDurationEstimate = word.length * 1000 / (utterance.rate * 5);
                    
//                     timingsRef.current[word] = {
//                         start: currentTime,
//                         end: currentTime + wordDurationEstimate
//                     };

//                     // Update the display
//                     document.getElementById("word").innerHTML = word;
//                     highlightCurrentWord(absoluteWordIndex);

//                     wordIndexRef.current++;
//                 }
//             }
//         };

//         utterance.onend = function() {
//             document.getElementById("word").innerHTML = "";
//             wordIndexRef.current = 0;
//             startIndexRef.current = 0;
//             setIsSpeaking(false);
//             document.getElementById("timings").textContent = JSON.stringify(timingsRef.current, null, 2);
//         };

//         utterance.onpause = function() {
//             setIsPaused(true);
//             setIsSpeaking(false);
//         };

//         utterance.onresume = function() {
//             setIsPaused(false);
//             setIsSpeaking(true);
//         };
//     };

//     const handlePause = () => {
//         if (speechSynthesis.speaking) {
//             speechSynthesis.pause();
//         }
//     };

//     const handleStop = () => {
//         speechSynthesis.cancel();
//         setIsSpeaking(false);
//         setIsPaused(false);
//         wordIndexRef.current = 0;
//         startIndexRef.current = 0;
//         document.getElementById("word").innerHTML = "";
//         resetHighlighting();
//     };

//     const handleWordClick = (index) => {
//         // Stop current speech
//         speechSynthesis.cancel();
        
//         // Reset highlighting
//         resetHighlighting();
        
//         // Start from clicked word
//         wordIndexRef.current = 0;
//         startIndexRef.current = index;
//         timingsRef.current = {};
        
//         const remainingText = globalWordsRef.current.slice(index).join(" ");
//         const utterance = utteranceRef.current;
//         utterance.text = remainingText;
        
//         // Highlight the first word immediately
//         highlightCurrentWord(index);
        
//         // Set up callbacks with the new starting index
//         setupUtteranceCallbacks(utterance, index);
        
//         speechSynthesis.speak(utterance);
//         setIsSpeaking(true);
//         setIsPaused(false);
//     };

//     const drawTextInPanel = (words_array) => {
//         const panel = document.getElementById("panel");
//         panel.innerHTML = '';
        
//         words_array.forEach((word, i) => {
//             const span = document.createElement('span');
//             span.id = "word_span_" + i;
//             span.textContent = word + ' ';
//             span.style.cursor = 'pointer';
//             span.onclick = () => handleWordClick(i);
//             panel.appendChild(span);
//         });
//     };

//     return (
//         <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
//             <h2>Speech Synthesis with Word Highlighting</h2>
            
//             <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
//                 <button
//                     onClick={handlePlay}
//                     style={{
//                         padding: '10px 20px',
//                         fontSize: '16px',
//                         backgroundColor: '#4CAF50',
//                         color: 'white',
//                         border: 'none',
//                         borderRadius: '4px',
//                         cursor: 'pointer'
//                     }}
//                     disabled={isSpeaking && !isPaused}
//                 >
//                     {isPaused ? 'Resume' : 'Play Speech'}
//                 </button>
                
//                 <button
//                     onClick={handlePause}
//                     style={{
//                         padding: '10px 20px',
//                         fontSize: '16px',
//                         backgroundColor: '#FFC107',
//                         color: 'black',
//                         border: 'none',
//                         borderRadius: '4px',
//                         cursor: 'pointer'
//                     }}
//                     disabled={!isSpeaking || isPaused}
//                 >
//                     Pause
//                 </button>
                
//                 <button
//                     onClick={handleStop}
//                     style={{
//                         padding: '10px 20px',
//                         fontSize: '16px',
//                         backgroundColor: '#F44336',
//                         color: 'white',
//                         border: 'none',
//                         borderRadius: '4px',
//                         cursor: 'pointer'
//                     }}
//                     disabled={!isSpeaking && !isPaused}
//                 >
//                     Stop
//                 </button>
//             </div>

//             <div style={{ marginBottom: '20px' }}>
//                 <strong>Current Word: </strong>
//                 <span id="word" style={{ fontSize: '18px', color: '#2196F3', fontWeight: 'bold' }}></span>
//             </div>

//             <div 
//                 id="panel"
//                 style={{
//                     border: '1px solid #ddd',
//                     padding: '15px',
//                     minHeight: '100px',
//                     backgroundColor: '#f9f9f9',
//                     marginBottom: '20px',
//                     lineHeight: '1.6'
//                 }}
//             >
//             </div>

//             <div>
//                 <h3>Word Timings:</h3>
//                 <pre 
//                     id="timings"
//                     style={{
//                         backgroundColor: '#f5f5f5',
//                         padding: '10px',
//                         border: '1px solid #ddd',
//                         borderRadius: '4px',
//                         overflow: 'auto',
//                         fontSize: '12px'
//                     }}
//                 >
//                 </pre>
//             </div>
//         </div>
//     );
// }
